import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { isBudgetManagerTableSwitchActive, setBudgetManagerTableSwitchToggle } from './obm-segments-table.state';

export const useObmSegmentsTable = () => {
    const dispatch = useDispatch();

    const isSwitchActive = useSelector(isBudgetManagerTableSwitchActive);

    const setSwitchToggle = useCallback((toogle) => {
        dispatch(setBudgetManagerTableSwitchToggle(toogle));
    }, [dispatch]);

    return {
        isSwitchActive,
        setSwitchToggle,
    };
};
